exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__Depth__root {\n  display: block;\n  overflow: hidden;\n  background-color: #ffffff;\n  border-radius: 16px;\n}\n\n.DS__Depth__depth_z0 {\n    border: 1px solid #dde3ed;\n  }\n\n.DS__Depth__depth_z50 {\n    box-shadow: 0px 4px 12px rgba(34, 42, 55, 0.04),\n      0px 0px 4px rgba(34, 42, 55, 0.04);\n  }\n\n.DS__Depth__depth_z100 {\n    box-shadow: 0 4px 10px rgba(34, 42, 55, 0.13);\n  }\n\n.DS__Depth__depth_z100W {\n    box-shadow: 0 0 1px 0 rgba(34, 42, 55, 0.13),\n      0 4px 10px rgba(34, 42, 55, 0.13);\n  }\n\n.DS__Depth__depth_z300 {\n    box-shadow: 0 8px 16px rgba(34, 42, 55, 0.13);\n  }\n\n.DS__Depth__depth_z300W {\n    box-shadow: 0 0 1px rgba(34, 42, 55, 0.13),\n      0 8px 16px rgba(34, 42, 55, 0.13);\n  }\n\n.DS__Depth__depth_z300B {\n    box-shadow: 0 8px 16px #d0d6e1;\n  }\n\n.DS__Depth__depth_z500 {\n    box-shadow: 0px 16px 32px rgba(34, 42, 55, 0.13);\n  }\n\n.DS__Depth__depth_z500W {\n    box-shadow: 0 16px 32px rgba(34, 42, 55, 0.13);\n  }\n\n.DS__Depth__enable_overflow {\n  overflow: visible;\n}\n\n.DS__Depth__flex {\n  display: flex;\n}\n", ""]);

// exports
exports.locals = {
	"root": "DS__Depth__root",
	"depth_z0": "DS__Depth__depth_z0",
	"depth_z50": "DS__Depth__depth_z50",
	"depth_z100": "DS__Depth__depth_z100",
	"depth_z100W": "DS__Depth__depth_z100W",
	"depth_z300": "DS__Depth__depth_z300",
	"depth_z300W": "DS__Depth__depth_z300W",
	"depth_z300B": "DS__Depth__depth_z300B",
	"depth_z500": "DS__Depth__depth_z500",
	"depth_z500W": "DS__Depth__depth_z500W",
	"enable_overflow": "DS__Depth__enable_overflow",
	"flex": "DS__Depth__flex"
};